/* WatchTender — "About this brand" block on product pages.
   Pulls the brand entry from the glossary data (wt-brands.js) and renders it
   under the product description, in the page's own language.
   Nothing is written to the product record; this is display only. */
(function () {
  if (location.pathname.indexOf('/products/') < 0) return;

  var LANG = (document.documentElement.getAttribute('lang') || 'ja').toLowerCase();
  var LG = LANG.indexOf('ja') === 0 ? 'ja' : LANG.indexOf('zh') === 0 ? 'zh' : LANG.indexOf('ko') === 0 ? 'ko' : 'en';
  var ROOT = (function () {
    try { var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; return r.replace(/\/+$/, ''); }
    catch (e) { return ({ ja: '', en: '/en', zh: '/zh', ko: '/ko' })[LG] || ''; }
  })();

  var T = {
    ja: { h: 'このブランドについて', more: '時計用語百科事典で見る →' },
    en: { h: 'About this brand', more: 'See it in the Encyclopedia of Watch Terms →' },
    zh: { h: '关于这个品牌', more: '在钟表术语百科中查看 →' },
    ko: { h: '이 브랜드에 대하여', more: '시계 용어 백과사전에서 보기 →' }
  }[LG];

  var SELECTORS = [
    '.product__description', '.product-single__description', '.product__description.rte',
    '.product-single__content .rte', '[data-product-description]', '.product-form__description',
    '#ProductInfo-template--main .rte', '.product__accordion .rte'
  ].join(',');

  function norm(s) {
    s = String(s || '').normalize ? String(s || '').normalize('NFKD') : String(s || '');
    s = s.replace(/[̀-ͯ]/g, '').toLowerCase();
    return s.replace(/[^a-z0-9]+/g, '');
  }

  function vendorOf() {
    try { if (window.meta && meta.product && meta.product.vendor) return meta.product.vendor; } catch (e) {}
    var ld = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < ld.length; i++) {
      try {
        var j = JSON.parse(ld[i].textContent);
        var arr = Array.isArray(j) ? j : [j];
        for (var k = 0; k < arr.length; k++) {
          var o = arr[k];
          if (o && o['@type'] === 'Product' && o.brand) {
            return (typeof o.brand === 'string') ? o.brand : (o.brand.name || '');
          }
        }
      } catch (e) {}
    }
    return '';
  }

  function pick(brands) {
    var idx = {};
    brands.forEach(function (b) { b.keys.forEach(function (k) { if (!idx[k]) idx[k] = b; }); });

    var v = norm(vendorOf());
    if (v && idx[v]) return idx[v];

    /* fall back to scanning the product title for a known brand, longest key first */
    var h1 = document.querySelector('h1');
    var title = norm(h1 ? h1.textContent : document.title);
    if (!title) return null;
    var keys = Object.keys(idx).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      if (keys[i].length >= 4 && title.indexOf(keys[i]) >= 0) return idx[keys[i]];
    }
    return null;
  }

  function style() {
    if (document.getElementById('wt-brand-css')) return;
    var st = document.createElement('style');
    st.id = 'wt-brand-css';
    st.textContent =
      ".wt-brand{margin:30px 0 0;padding:20px 22px;border:1px solid rgba(18,48,44,.13);border-radius:12px;" +
      "background:linear-gradient(170deg,#F0FBF6 0%,#E4F6ED 100%);color:#1C3735;" +
      "font-family:-apple-system,BlinkMacSystemFont,'Hiragino Sans','Noto Sans JP',sans-serif;line-height:1.95}" +
      ".wt-brand-k{margin:0;font-size:10.5px;letter-spacing:.22em;color:#C4A864;font-weight:600}" +
      ".wt-brand-n{margin:7px 0 0;font-size:18px;font-weight:600;color:#12302C;" +
      "font-family:'Hiragino Mincho ProN','Yu Mincho','Noto Serif JP',serif;letter-spacing:.02em}" +
      ".wt-brand-d{margin:10px 0 0;font-size:13.5px}" +
      ".wt-brand-m{display:inline-block;margin-top:12px;font-size:12.5px;color:#12302C;text-decoration:none;" +
      "border-bottom:1px solid #C4A864;padding-bottom:2px}" +
      "@media (max-width:600px){.wt-brand{padding:17px 16px}.wt-brand-d{font-size:13px}}";
    (document.head || document.documentElement).appendChild(st);
  }

  function render(b) {
    if (document.querySelector('.wt-brand')) return;
    var host = document.querySelector(SELECTORS);
    if (!host) return;
    style();
    /* if the description sits inside a collapsible <details>, place the block
       after the whole accordion so it is visible without opening anything */
    var anchor = host, n = host;
    for (var i = 0; i < 6 && n && n.parentNode; i++) {
      n = n.parentNode;
      if (n.tagName === 'DETAILS') { anchor = n; }
    }
    var box = document.createElement('aside');
    box.className = 'wt-brand';
    var k = document.createElement('p'); k.className = 'wt-brand-k'; k.textContent = T.h;
    var n = document.createElement('p'); n.className = 'wt-brand-n'; n.textContent = b.h[LG] || b.h.en;
    var d = document.createElement('p'); d.className = 'wt-brand-d'; d.textContent = b.d[LG] || b.d.ja;
    var a = document.createElement('a'); a.className = 'wt-brand-m';
    a.href = ROOT + '/pages/watch-glossary?term=' + encodeURIComponent(b.ja);
    a.textContent = T.more;
    box.appendChild(k); box.appendChild(n); box.appendChild(d); box.appendChild(a);
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  function run() {
    var brands = window.WT_BRANDS;
    if (!brands || !brands.length) return;
    var b = pick(brands);
    if (b) render(b);
  }
  function boot(tries) {
    tries = tries || 0;
    if (window.WT_BRANDS && document.querySelector(SELECTORS)) { run(); return; }
    if (tries < 40) setTimeout(function () { boot(tries + 1); }, 200);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); });
  else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 80); });
})();
